var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82812 8.00004C6.82812 7.35571 7.35046 6.83337 7.99479 6.83337H8.00079C8.64512 6.83337 9.16746 7.35571 9.16746 8.00004C9.16746 8.64437 8.64512 9.16671 8.00079 9.16671H7.99479C7.35046 9.16671 6.82812 8.64437 6.82812 8.00004Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82275 12C6.82275 11.3557 7.34509 10.8334 7.98942 10.8334H7.99542C8.63975 10.8334 9.16209 11.3557 9.16209 12C9.16209 12.6444 8.63975 13.1667 7.99542 13.1667H7.98942C7.34509 13.1667 6.82275 12.6444 6.82275 12Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8335 4.00004C6.8335 3.35571 7.35583 2.83337 8.00016 2.83337H8.00616C8.6505 2.83337 9.17283 3.35571 9.17283 4.00004C9.17283 4.64437 8.6505 5.16671 8.00616 5.16671H8.00016C7.35583 5.16671 6.8335 4.64437 6.8335 4.00004Z",
    fill: "#585858"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertical);
export default __webpack_public_path__ + "static/media/more-vertical.35149531c91b39da55e67778140b7b05.svg";
export { ForwardRef as ReactComponent };